import { Injectable } from '@angular/core';
import { ArcService } from './arc.service';


@Injectable()
export class UtilsService {
  uniqueIdentifiersLs: string[];
  auths;

  constructor(private arcs: ArcService) {
    arcs.utils = this
  }

  jsonRecordId(txt) {
    let ls = []
    for (let i = 0; i < txt.length; i++)
      ls.push(txt.charAt(i).charCodeAt(0).toString(36))
    return `r${ls.join('')}`
  }

  saveExport(data, filename) {
    var hiddenElement = document.createElement('a');
    hiddenElement.href = URL.createObjectURL(new Blob([JSON.stringify(data)], { type: 'text/plain' }));
    hiddenElement.target = '_blank';
    hiddenElement.download = filename;
    hiddenElement.click();
    hiddenElement.remove()
  }

  get uniqueIdentifier() {
      if (!this.uniqueIdentifiersLs || this.uniqueIdentifiersLs.length < 5) {
        let r = this.arcs.run({
          fun: 'generateUniqueIdentifiers',
        })
        r.subscribe((ls) => this.uniqueIdentifiersLs = ls)
        if (!this.uniqueIdentifiersLs)
          return null
      }
      return this.uniqueIdentifiersLs.pop();
    }

    get email() {
      return this.auths.email
    }

    get isAdmin() {
      return this.auths && this.auths.isAdmin
    }

    get authenticated() {
      if (!this.auths)
        return false
      return this.auths.authenticated
    }


    login() {
        this.auths.login()
      }

      logout() {
        this.auths.logout()
      }

}



// WEBPACK FOOTER //
// ./src/app/utils.service.ts